export const apiBaseURLs = { default: "/api/v1" };

// If other than /, this has to be the same as what is stored in package.json.
// I can't figure out how to access package.json directly, as the standard
// create-react-app configuration limits imports to the src directory.
export const homepage = "/personal-portal";

export const title = "Fields Institute Personal Portal";

export const helpAddress = "portal-help@fields.utoronto.ca";
